import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HistoryState } from "./AccountDropdown";
import dealerRoles from "../../util/dealerAccounts";

function useDropdownSelection(
  returnedPath: string,
  historyState: HistoryState
) {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<
    Element | (() => Element) | null | undefined
  >(null);

  const email = JSON.parse(
    sessionStorage.getItem("email") || JSON.stringify("")
  );

  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/logout");
  };

  const routeToSettings = () => {
    if (dealerRoles.includes(role)) {
      navigate("/userSettings", {
        state: {
          userId: JSON.parse(
            sessionStorage.getItem("user") || JSON.stringify("")
          ),
          previous: returnedPath,
          ...historyState,
        },
      });
    }
  };

  return {
    anchorEl,
    email,
    role,
    handleClick,
    handleClose,
    handleSignOut,
    routeToSettings,
  };
}

export default useDropdownSelection;
